import { defineStore } from "pinia";
import type { Plan, PlanPrice } from "@phurshell/psiapp-frontend-core/domain";

export const useSubscriptionInfoStore = defineStore("subscriptionInfo", {
  state: (): { plan: Plan | null; price: PlanPrice | null } => ({
    plan: null,
    price: null,
  }),
  persist: true,
  actions: {
    save(params: { plan: Plan | null; price: PlanPrice | null }) {
      this.plan = params.plan;
      this.price = params.price;
    },
    clear() {
      this.plan = null;
      this.price = null;
    },
  },
});
